import { CropMode, Emotion } from '@d-id/studio/src/utils/types';
import { Providers } from '@d-id/types';
import { FaceRect, VideoType } from '../entities';

export interface Scene {
    id: string;
    image_url?: string;
    overlay_url?: string;
    thumbnail_url: string;
    crop_mode: CropMode;
    script?: any;
    duration?: number;
    presenter?: ScenePresenter;
}

export type ScenePresenter = SceneTalksPresenter | SceneClipsPresenter | SceneExpressPresenter;

interface TalksConfig {
    driver_expressions?: {
        expressions: {
            expression: Emotion;
            start_frame: number;
            intensity: number;
        }[];
    };
}

interface BasePresenter {
    type: VideoType;
    position: {
        top: string;
        left: string;
        height: string;
        width?: string;
        crop?: FaceRect;
    };
    ssml?: any;
    voice?: { type: Providers; voice_id: string };
    voice_id?: string;
    gender?: string;
}

export interface SceneTalksPresenter extends BasePresenter {
    source_url: string;
    driver_url?: string;
    config?: TalksConfig;
}

export interface SceneClipsPresenter extends BasePresenter {
    presenter_id: string;
    id?: string;
    driver_id?: string;
    background?: {
        color: string;
    };
}

export interface SceneExpressPresenter extends BasePresenter {
    avatar_id: string;
}

export const isClipsPresenter = (presenter: ScenePresenter): presenter is SceneClipsPresenter =>
    presenter.type === VideoType.CLIP;
export const isTalksPresenter = (presenter: ScenePresenter): presenter is SceneTalksPresenter =>
    presenter.type === VideoType.TALK;
